import { render, staticRenderFns } from "./SubmitOtp.vue?vue&type=template&id=24fed2d3&"
import script from "./SubmitOtp.vue?vue&type=script&lang=js&"
export * from "./SubmitOtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports